export default {
  develop: window.location.href.indexOf('localhost') !== -1,
  apiURL: process.env.API_ENDPOINT,
  regions: {
    '1': {
      region_id: '1',
      region_name: {
        'ja': '北海道',
        'en': 'Hokkaido',
        'zh-CN': '北海道',
        'zh-TW': '北海道',
        'ko': '홋카이도',
        'ru': 'Хоккайдо',
        'fr': 'Hokkaidô',
        'de': 'Hokkaidō',
        'es': 'Hokkaido',
        'pt': 'Hokkaido',
        'it': 'Hokkaido',
        'th': 'ฮอกไกโด'
      },
      prefectures: [
        {
          prefecture_id: '01',
          prefecture_name: '北海道'
        }
      ]
    },
    '2': {
      region_id: '2',
      region_name: {
        'ja': '東北',
        'en': 'Tohoku region',
        'zh-CN': '东北',
        'zh-TW': '東北',
        'ko': '도호쿠',
        'ru': 'Тохоку',
        'fr': 'Région de Tôhoku',
        'de': 'Region Tōhoku',
        'es': 'Región de Tohoku',
        'pt': 'Região de Tohoku',
        'it': 'Regione di Tohoku',
        'th': 'โทโฮคุ'
      },
      prefectures: [
        {
          prefecture_id: '02',
          prefecture_name: '青森県'
        },
        {
          prefecture_id: '03',
          prefecture_name: '岩手県'
        },
        {
          prefecture_id: '04',
          prefecture_name: '宮城県'
        },
        {
          prefecture_id: '05',
          prefecture_name: '秋田県'
        },
        {
          prefecture_id: '06',
          prefecture_name: '山形県'
        },
        {
          prefecture_id: '07',
          prefecture_name: '福島県'
        }
      ]
    },
    '3': {
      region_id: '3',
      region_name: {
        'ja': '関東',
        'en': 'Kanto region',
        'zh-CN': '关东',
        'zh-TW': '關東',
        'ko': '간토',
        'ru': 'Канто',
        'fr': 'Région de Kantô',
        'de': 'Region Kantō',
        'es': 'Región de Kanto',
        'pt': 'Região de Kanto',
        'it': 'Regione di Kanto',
        'th': 'คันโต'
      },
      prefectures: [
        {
          prefecture_id: '08',
          prefecture_name: '茨城県'
        },
        {
          prefecture_id: '09',
          prefecture_name: '栃木県'
        },
        {
          prefecture_id: '10',
          prefecture_name: '群馬県'
        },
        {
          prefecture_id: '11',
          prefecture_name: '埼玉県'
        },
        {
          prefecture_id: '12',
          prefecture_name: '千葉県'
        },
        {
          prefecture_id: '13',
          prefecture_name: '東京都'
        },
        {
          prefecture_id: '14',
          prefecture_name: '神奈川県'
        }
      ]
    },
    '4': {
      region_id: '4',
      region_name: {
        'ja': '中部',
        'en': 'Chubu region',
        'zh-CN': '中部',
        'zh-TW': '中部',
        'ko': '주부',
        'ru': 'Тюбу',
        'fr': 'Région de Chûbu',
        'de': 'Region Chūbu',
        'es': 'Región de Chubu',
        'pt': 'Região de Chubu',
        'it': 'Regione di Chubu',
        'th': 'จูบุ'
      },
      prefectures: [
        {
          prefecture_id: '15',
          prefecture_name: '新潟県'
        },
        {
          prefecture_id: '16',
          prefecture_name: '富山県'
        },
        {
          prefecture_id: '17',
          prefecture_name: '石川県'
        },
        {
          prefecture_id: '18',
          prefecture_name: '福井県'
        },
        {
          prefecture_id: '19',
          prefecture_name: '山梨県'
        },
        {
          prefecture_id: '20',
          prefecture_name: '長野県'
        },
        {
          prefecture_id: '21',
          prefecture_name: '岐阜県'
        },
        {
          prefecture_id: '22',
          prefecture_name: '静岡県'
        },
        {
          prefecture_id: '23',
          prefecture_name: '愛知県'
        }
      ]
    },
    '5': {
      region_id: '5',
      region_name: {
        'ja': '近畿',
        'en': 'Kinki region',
        'zh-CN': '近畿',
        'zh-TW': '近畿',
        'ko': '긴키',
        'ru': 'Кинки',
        'fr': 'Région de Kinki',
        'de': 'Region Kinki',
        'es': 'Región de Kinki',
        'pt': 'Região de Kinki',
        'it': 'Regione di Kinki',
        'th': 'คินคิ'
      },
      prefectures: [
        {
          prefecture_id: '24',
          prefecture_name: '三重県'
        },
        {
          prefecture_id: '25',
          prefecture_name: '滋賀県'
        },
        {
          prefecture_id: '26',
          prefecture_name: '京都府'
        },
        {
          prefecture_id: '27',
          prefecture_name: '大阪府'
        },
        {
          prefecture_id: '28',
          prefecture_name: '兵庫県'
        },
        {
          prefecture_id: '29',
          prefecture_name: '奈良県'
        },
        {
          prefecture_id: '30',
          prefecture_name: '和歌山県'
        }
      ]
    },
    '6': {
      region_id: '6',
      region_name: {
        'ja': '中国・四国',
        'en': 'Chugoku & Shikoku',
        'zh-CN': '中国・四国',
        'zh-TW': '中國・四國',
        'ko': '주고쿠・시코쿠',
        'ru': 'Тюгоку и Сикоку',
        'fr': 'Chûgoku et Shikoku',
        'de': 'Chūgoku und Shikoku',
        'es': 'Chugoku y Shikoku',
        'pt': 'Chugoku e Shikoku',
        'it': 'Chugoku e Shikoku',
        'th': 'จูโกคุ,ชิโกค'
      },
      prefectures: [
        {
          prefecture_id: '31',
          prefecture_name: '鳥取県'
        },
        {
          prefecture_id: '32',
          prefecture_name: '島根県'
        },
        {
          prefecture_id: '33',
          prefecture_name: '岡山県'
        },
        {
          prefecture_id: '34',
          prefecture_name: '広島県'
        },
        {
          prefecture_id: '35',
          prefecture_name: '山口県'
        },
        {
          prefecture_id: '36',
          prefecture_name: '徳島県'
        },
        {
          prefecture_id: '37',
          prefecture_name: '香川県'
        },
        {
          prefecture_id: '38',
          prefecture_name: '愛媛県'
        },
        {
          prefecture_id: '39',
          prefecture_name: '高知県'
        }
      ]
    },
    '7': {
      region_id: '7',
      region_name: {
        'ja': '九州・沖縄',
        'en': 'Kyushu & Okinawa',
        'zh-CN': '九州・冲绳',
        'zh-TW': '九州・沖繩',
        'ko': '규슈・오키나와',
        'ru': 'Кюсю и Окинава',
        'fr': 'Kyûshû et Okinawa',
        'de': 'Kyūshū und Okinawa',
        'es': 'Kyushu y Okinawa',
        'pt': 'Kyushu e Okinawa',
        'it': 'Kyushu e Okinawa',
        'th': 'โอกินาวา'
      },
      prefectures: [
        {
          prefecture_id: '40',
          prefecture_name: '福岡県'
        },
        {
          prefecture_id: '41',
          prefecture_name: '佐賀県'
        },
        {
          prefecture_id: '42',
          prefecture_name: '長崎県'
        },
        {
          prefecture_id: '43',
          prefecture_name: '熊本県'
        },
        {
          prefecture_id: '44',
          prefecture_name: '大分県'
        },
        {
          prefecture_id: '45',
          prefecture_name: '宮崎県'
        },
        {
          prefecture_id: '46',
          prefecture_name: '鹿児島県'
        },
        {
          prefecture_id: '47',
          prefecture_name: '沖縄県'
        }
      ]
    },
    '99': {
      region_id: '99',
      region_name: {
        'ja': 'その他',
        'en': 'Others',
        'zh-CN': 'Others',
        'zh-TW': 'Others',
        'ko': 'Others',
        'ru': 'Others',
        'fr': 'Others',
        'de': 'Others',
        'es': 'Others',
        'pt': 'Others',
        'it': 'Others',
        'th': 'Others'
      },
      prefectures: []
    }
  },
  prefecturesList: {
    '01': 1,
    '02': 2,
    '03': 2,
    '04': 2,
    '05': 2,
    '06': 2,
    '07': 2,
    '08': 3,
    '09': 3,
    '10': 3,
    '11': 3,
    '12': 3,
    '13': 3,
    '14': 3,
    '15': 4,
    '16': 4,
    '17': 4,
    '18': 4,
    '19': 4,
    '20': 4,
    '21': 4,
    '22': 4,
    '23': 4,
    '24': 5,
    '25': 5,
    '26': 5,
    '27': 5,
    '28': 5,
    '29': 5,
    '30': 5,
    '31': 6,
    '32': 6,
    '33': 6,
    '34': 6,
    '35': 6,
    '36': 6,
    '37': 6,
    '38': 6,
    '39': 6,
    '40': 7,
    '41': 7,
    '42': 7,
    '43': 7,
    '44': 7,
    '45': 7,
    '46': 7,
    '47': 7
  },
  facebookLangCode: {
    'ja': 'ja_JP',
    'en': 'en_US',
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_TW',
    'ko': 'ko_KR',
    'ru': 'ru_RU',
    'fr': 'fr_FR',
    'de': 'de_DE',
    'es': 'es_ES',
    'pt': 'pt_PT',
    'it': 'it_IT',
    'th': 'th_TH'
  }
}



// WEBPACK FOOTER //
// ./src/setting.js